import { MuiSelect } from "../../components/SimpleSelect/simpleselect-overrides.js";
import { MuiTypography } from "../../components/Typography/typography-overrides.js";
import { MuiCheckbox } from "../../components/Checkbox/checkbox-overrides.js";
import { MuiSwitch } from "../../components/Switch/switch-overrides.js";
import { MuiRadio } from "../../components/RadioGroup/radio-overrides.js";
import { MuiAlert } from "../../components/Alert/alert-overrides.js";
import { MuiAvatar } from "../../components/Avatar/avatar-overrides.js";
import { MuiButton } from "../../components/Button/button-overrides.js";
import { MuiChip } from "../../components/Chip/chip-overrides.js";
import { MuiDialog, MuiDialogTitle } from "../../components/Modal/modal-overrides.js";
import { MuiDrawer } from "../../components/Drawer/drawer-overrides.js";
import { MuiIconButton } from "../../components/IconButton/icon-button-overrides.js";
import { MuiMenu } from "../../components/Menu/menu-overrides.js";
import { MuiMenuItem } from "../../components/Menu/menuitem-overrides.js";
import { MuiAutocomplete } from "../../components/MultiSelect/multiselect-overrides.js";
import { MuiStack } from "../../components/Stack/stack-overrides.js";
import { MuiTab, MuiTabs } from "../../components/TabGroup/tabgroup-overrides.js";
import { MuiTextField } from "../../components/TextField/textfield-overrides.js";
import { MuiTooltip } from "../../components/Tooltip/tooltip-overrides.js";
import { MuiToggleButtonGroup } from "../../components/ToggleButtonGroup/togglebuttongroup-overrides.js";
import { MuiToggleButton } from "../../components/ToggleButtonGroup/togglebutton-overrides.js";
import { MuiPickersCalendarHeader } from "../../components/DateTimePicker/overrides/pickers-calendar-header-overrides.js";
import { MuiPickersDay } from "../../components/DateTimePicker/overrides/pickers-day-overrides.js";
import { MuiPopover } from "../../components/Popover/popover-overrides.js";
import { MuiDateCalendar } from "../../components/DateTimePicker/overrides/date-calendar-overrides.js";
import { MuiDateRangeCalendar } from "../../components/DateTimePicker/overrides/date-range-calendar-overrides.js";
import { MuiDateRangePickerDay } from "../../components/DateTimePicker/overrides/date-range-picker-day-overrides.js";
import { MuiBreadcrumbs } from "./breadcrumb-overrides.js";
import { MuiButtonGroup } from "./button-group.js";
import { MuiFab } from "./fab.js";
import { MuiFormControl } from "./form-control.js";
import { MuiFormLabel } from "./form-label.js";
import { MuiInputBase } from "./input-base.js";
import { MuiInputLabel } from "./input-label.js";
import { MuiLink } from "./link.js";
import { MuiListSubheader } from "./list-subheader.js";
import { MuiMultiSectionDigitalClock } from "./multi-section-digital-clock-overrides.js";
import { MuiOutlinedInput } from "./outlined-input.js";
import { MuiPaper } from "./paper.js";
import { MuiTable } from "./table.js";
import { MuiTableCell } from "./table-cell.js";
import { MuiTablePagination } from "./table-pagination.js";
import { MuiTableRow } from "./table-row.js";
const components = {
    MuiAlert: MuiAlert,
    MuiAutocomplete: MuiAutocomplete,
    MuiAvatar: MuiAvatar,
    MuiBreadcrumbs: MuiBreadcrumbs,
    MuiButton: MuiButton,
    MuiButtonGroup: MuiButtonGroup,
    MuiCheckbox: MuiCheckbox,
    MuiChip: MuiChip,
    MuiDateCalendar: MuiDateCalendar,
    MuiDateRangeCalendar: MuiDateRangeCalendar,
    MuiDateRangePickerDay: MuiDateRangePickerDay,
    MuiDialog: MuiDialog,
    MuiDialogTitle: MuiDialogTitle,
    MuiDrawer: MuiDrawer,
    MuiFab: MuiFab,
    MuiFormControl: MuiFormControl,
    MuiFormLabel: MuiFormLabel,
    MuiIconButton: MuiIconButton,
    MuiInputBase: MuiInputBase,
    MuiInputLabel: MuiInputLabel,
    MuiLink: MuiLink,
    MuiListSubheader: MuiListSubheader,
    MuiMenu: MuiMenu,
    MuiMenuItem: MuiMenuItem,
    MuiMultiSectionDigitalClock: MuiMultiSectionDigitalClock,
    MuiOutlinedInput: MuiOutlinedInput,
    MuiPaper: MuiPaper,
    MuiPickersCalendarHeader: MuiPickersCalendarHeader,
    MuiPickersDay: MuiPickersDay,
    MuiPopover: MuiPopover,
    MuiRadio: MuiRadio,
    MuiSelect: MuiSelect,
    MuiStack: MuiStack,
    MuiSwitch: MuiSwitch,
    MuiTab: MuiTab,
    MuiTable: MuiTable,
    MuiTableCell: MuiTableCell,
    MuiTablePagination: MuiTablePagination,
    MuiTableRow: MuiTableRow,
    MuiTabs: MuiTabs,
    MuiTextField: MuiTextField,
    MuiToggleButton: MuiToggleButton,
    MuiToggleButtonGroup: MuiToggleButtonGroup,
    MuiTooltip: MuiTooltip,
    MuiTypography: MuiTypography
};
export { components };

//# sourceMappingURL=index.js.map